<div bsModal #createOrEditModal="bs-modal" style="z-index: 1050;" class="modal fade approve-modal" tabindex="-1" role="dialog" aria-labelledby="createOrEditModal" aria-hidden="true" [config]="{backdrop: 'static'}">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form *ngIf="active" #workFlowItemForm="ngForm" novalidate (ngSubmit)="save()" autocomplete="off">
                <div class="modal-header">
                    <h4 class="modal-title">
                        <span>{{l("History")}} {{title}}</span>
                    </h4>                    
                    
                    
                 <button type="button" class="btn-close" (click)="close()" aria-label="Close" [disabled]="saving"></button>
             
                </div>
                <div class="modal-body">
                 

                    <workFlowItemDetail #workFlowItemDetail></workFlowItemDetail>
					
					

                </div>
                <div class="modal-footer">
                    <button [disabled]="saving" type="button" class="btn btn-default" (click)="close()">{{l("Cancel")}}</button>
                </div>
            </form>
        </div>
    </div>

</div>